'use client'

import { useEffect } from 'react'
import posthog from 'posthog-js'
import { runWhenIdleOrInteractive } from '@/lib/defer'

const GA_ID = 'G-D83F82KSGK'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

/**
 * Loads the heavy, non-essential analytics after first interaction or
 * post-load idle: the gtag bundle (~177 KiB) and PostHog's lazily-fetched
 * session recorder. PostHog core stays eager (instrumentation-client.ts) so
 * capture/identify calls are never dropped.
 */
export function DeferredAnalytics() {
  useEffect(() => {
    runWhenIdleOrInteractive(() => {
      try {
        window.dataLayer = window.dataLayer || []
        window.gtag = function gtag() {
          // eslint-disable-next-line prefer-rest-params
          window.dataLayer!.push(arguments)
        }
        window.gtag('js', new Date())
        window.gtag('config', GA_ID)

        const script = document.createElement('script')
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
        script.async = true
        document.head.appendChild(script)
      } catch (e) {
        console.warn('Google Analytics initialization failed:', e)
      }

      try {
        posthog.startSessionRecording()
      } catch (e) {
        console.warn('PostHog session recording failed to start:', e)
      }
    })
  }, [])

  return null
}
